module.exports = __webpack_public_path__ + "img/03.62b750b9.jpg";